// frontend/src/components/BoardingDisplay.js
import { ClipboardCheck, UserCheck, Briefcase, AlertTriangle } from 'lucide-react';

const BoardingDisplay = ({ tripData, onStartTrip }) => {
    const totalBookings = parseInt(tripData.total_bookings) || 0;
    const totalRiders = parseInt(tripData.total_riders) || 0;
    const totalLuggage = parseInt(tripData.total_luggages) || 0;

    return (
        <div className="space-y-4">
            <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 rounded">
                <div className="flex items-center">
                    <AlertTriangle className="h-5 w-5 text-yellow-400" />
                    <p className="ml-3 text-sm text-yellow-700">
                        Please ensure all passengers are boarded before starting the trip
                    </p>
                </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                <div className="bg-white p-4 rounded-lg shadow">
                    <div className="flex items-center gap-2 mb-2">
                        <ClipboardCheck className="h-5 w-5 text-blue-500" />
                        <h3 className="font-medium">Bookings</h3>
                    </div>
                    <p className="text-2xl font-bold">{totalBookings}</p>
                    <p className="text-sm text-gray-500">Total bookings for this trip</p>
                </div>

                <div className="bg-white p-4 rounded-lg shadow">
                    <div className="flex items-center gap-2 mb-2">
                        <UserCheck className="h-5 w-5 text-green-500" />
                        <h3 className="font-medium">Passengers</h3>
                    </div>
                    <p className="text-2xl font-bold">{totalRiders}</p>
                    <p className="text-sm text-gray-500">Expected passengers</p>
                </div>

                <div className="bg-white p-4 rounded-lg shadow">
                    <div className="flex items-center gap-2 mb-2">
                        <Briefcase className="h-5 w-5 text-purple-500" />
                        <h3 className="font-medium">Luggage</h3>
                    </div>
                    <p className="text-2xl font-bold">{totalLuggage}</p>
                    <p className="text-sm text-gray-500">Expected luggage items</p>
                </div>
            </div>

            <div className="bg-white p-4 rounded-lg shadow">
                <h3 className="font-medium mb-3">Pre-Trip Checklist</h3>
                <div className="space-y-2">
                    <div className="flex items-center gap-2">
                        <input type="checkbox" className="form-checkbox h-4 w-4 text-blue-500" />
                        <span>Verify shuttle is at the first pickup location</span>
                    </div>
                    <div className="flex items-center gap-2">
                        <input type="checkbox" className="form-checkbox h-4 w-4 text-blue-500" />
                        <span>Check all passengers against booking list</span>
                    </div>
                    <div className="flex items-center gap-2">
                        <input type="checkbox" className="form-checkbox h-4 w-4 text-blue-500" />
                        <span>Assist with luggage loading</span>
                    </div>
                    <div className="flex items-center gap-2">
                        <input type="checkbox" className="form-checkbox h-4 w-4 text-blue-500" />
                        <span>Ensure all passengers are safely seated</span>
                    </div>
                </div>
            </div>

            <button 
                onClick={onStartTrip}
                className="w-full py-3 bg-green-500 text-white rounded-lg hover:bg-green-600 transition-colors"
            >
                Start Trip
            </button>
        </div>
    );
};

export default BoardingDisplay;